import Cookies from 'js-cookie';
import { TCookieOptions } from '../types/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const encode = (cookieValue: any) => {
  if (!window) {
    return;
  }
  try {
    return window.btoa(JSON.stringify(cookieValue)).replace(/=/g, '-');
  } catch (err) {
    console.error(
      'CookieManager: Failed to encode cookie value in fabric-registration-v2',
    );
  }
};

const decodeCookieValue = (cookieValue?: string): string | undefined => {
  if (!cookieValue) return;

  try {
    return window.atob(cookieValue.replace(/-/g, '='));
  } catch (error) {
    console.error('CookieManager: Failed to decode cookie value in fabric-registration-v2', error);
  }
};

export const readCookie = (
  cookieName: string,
  { decode: decodeFlag = true, parse: parseFlag = true } = {},
) => {
  const cookieValue = Cookies.get(cookieName);
  if (!cookieValue) {
    return parseFlag ? {} : '';
  } else {
    const cookieValueProcessed = decodeFlag ? decodeCookieValue(cookieValue) : cookieValue;
    if (!parseFlag) {
      return cookieValueProcessed;
    }
    if (cookieValueProcessed) {
      try {
        return JSON.parse(cookieValueProcessed);
      } catch (err) {
        console.error(`CookieManager: Failed to read cookie ${cookieName}`);
      }
    }

  }
};

export const getCookieData = (cookieName: string, dataKey: string) => {
  const cookieData = readCookie(cookieName) || {};

  return cookieData[dataKey] || '';
};

//TODO: Revisit and refactor this, not even sure why we need it
export const storeInRawCookie = (
  cookieName: string,
  value: string,
  options: TCookieOptions,
) => {
  if (!window) {
    return;
  }
  const {
    path = '/',
    expires = 365,
    secure = window.location.protocol === 'https:',
    sameSite = 'lax',
  } = options;

  let cookieString = `${encodeURIComponent(cookieName)}=${encodeURIComponent(
    value,
  )}`;

  if (expires) {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + expires);
    cookieString += `; expires=${expirationDate.toUTCString()}`;
  }

  if (path) {
    cookieString += `; path=${path}`;
  }

  if (secure) {
    cookieString += `; secure`;
  }

  if (sameSite) {
    cookieString += `; samesite=${sameSite}`;
  }

  document.cookie = cookieString;
};

export const storeInCookie = (
  cookieName: string,
  key: string,
  value: string,
  options: TCookieOptions = {},
  // By default the cookie is always an object. With simpleString flag you can create a cookie with string value...
  { encode: encodeFlag = true, simpleString = false } = {},
) => {
  try {
    const newCookieValue = readCookie(cookieName, { decode: encodeFlag });
    newCookieValue[key] = value;

    const encodedCookie = encodeFlag ? encode(newCookieValue) : newCookieValue;
    simpleString
      ? storeInRawCookie(cookieName, value, options)
      : storeInRawCookie(cookieName, encodedCookie, options);
  } catch (err) {
    console.error('CookieManager: Error storing cookie', err);
  }
};

export const getCookieByName = (name: string) => {
  if (window && name) {
    const value = `; ${document?.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts?.length === 2) {
      const part = parts?.pop();

      return part ? part.split(';').shift() : undefined;
    }
  }
};

export const deleteCookieByName = (cookieName: string) => {
  document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
};
